import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=8af38862&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=ts&"
export * from "./AppIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=8af38862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af38862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
